// Melding op het bord als het gezinsbord verwijderd gaat worden (0036). Engelse tegenhanger.
export const kioskPrivacyEn = {
    closingTitle: 'This board stops on {date}',
    closingBody: 'Not right? A parent can still stop it in the app.',
};
//# sourceMappingURL=kioskPrivacy.en.js.map